<template lang="pug">
v-app
  v-main(v-if="token")
    router-view
</template>

<script>

import "./assets/sass/style.sass";
import { AuthRequest } from "./api/index";
import { commonMixin } from "./shared/mixins";

export default {
  name: 'App',

  data: () => ({
    token: null
  }),

  mixins: [
    commonMixin  
  ],

  async mounted () {
    await this.AuthRequest();
    history.replaceState(null, '', '#');
  },

  methods: {
    async AuthRequest() {
      let token = this.getTokenFromCookies();
      let token_obj = await AuthRequest(token, this);
      if (token_obj) {
        this.token = token_obj.token;
        this.$cookies.set("user_role_id", token_obj.user_role_id, token_obj.expire);
      } else {
        this.LogOut()
      }
    },
  }
};
</script>
